import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import strings from "../translations";
import { useLocalStorage } from "../hooks";
import { supportedLanguageShortCodes } from "../helpers/supported-languages";
import { useTranslation } from "react-i18next";

const LanguageContext = createContext();

export function useLanguageContext() {
  const context = useContext(LanguageContext);
  if (context == undefined) {
    throw new Error(
      "useLanguageContext must be used within an LanguageProvider"
    );
  }
  return context;
}

const InitialLanguage = "en";

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useLocalStorage("language", InitialLanguage);
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
    console.log(`Language changed to ${lang}`);
  };

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      changeLanguage,
      strings,
    }),
    [language]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
